import { Component } from '@angular/core';

import { AuthorizationService } from './../../../shared/index';
//import { CatalogService } from "./../../index";

@Component({
    selector: 'user-index',
    templateUrl: './user-index.html',
    standalone: false
})

export class UserIndexComponent {
    constructor(
        private _authorizationService: AuthorizationService,
        //private _catalogService: CatalogService
    ) { }

    //public isInRole(component: string): boolean {
    //    return this._authorizationService.hasRole(component);
    //}
}
